import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';

import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { TabsPage } from '../tabs/tabs';
import { LoginPage } from '../login/login';
import { AuthProvider } from '../../providers/auth/auth.provider';



@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html'
})
export class RegisterPage {

  registerForm: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    public formBuilder: FormBuilder
  ) {}

  ionViewWillLoad(){
    this.registerForm = this.formBuilder.group({
      email: new FormControl(),
      password: new FormControl()
    });
  }

  tryRegister(value){
    this.authProvider.doRegister(value)
     .then(res => {
       this.errorMessage = "";
       this.successMessage = "Your account has been created. Please log in now.";
     }, err => {
       this.errorMessage = err.message;
       this.successMessage = "";
     })
  }

  tryFacebookLogin(){
    this.authProvider.doFacebookLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryGoogleLogin(){
    this.authProvider.doGoogleLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  tryTwitterLogin(){
    this.authProvider.doTwitterLogin()
    .then((res) => {
      this.navCtrl.setRoot(TabsPage);
    }, (err) => {
      this.errorMessage = err.message;
    });
  }

  goLoginPage(){
    this.navCtrl.push(LoginPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts